import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { ART_RECIPES, ART_STYLE } from "./VisualSystem"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Returns the current active art recipe based on the master VisualSystem config.
 */
export function getActiveRecipe() {
  const style = ART_STYLE.NAME;
  return ART_RECIPES[style as keyof typeof ART_RECIPES] || ART_RECIPES.PRISTINE_LIGHT;
}

/**
 * Universal helper to apply a specific visual token.
 */
export function getStyleToken(token: keyof ReturnType<typeof getActiveRecipe>) {
  return getActiveRecipe()[token];
}
